/** Проверка и авто-подбор столбца ФИО / контакта для сравнения файлов. */

export function getManualHeaderLabelForDetect(headers, renames, ci) {
  const renamed = renames?.[ci];
  if (renamed != null && String(renamed).trim() !== '') return String(renamed).trim();
  return String(headers?.[ci] ?? '').trim();
}

export function detectManualCrossFioCol(headers, renames) {
  if (!Array.isArray(headers)) return -1;
  const normalized = headers.map((h, ci) => getManualHeaderLabelForDetect(headers, renames, ci).toLowerCase());
  const fioNames = [
    'фио', 'ф.і.о', 'ф і о', 'піб', 'pib', 'ім\'я', 'имя', 'контакт', 'отримувач', 'отримувача',
    'получатель', 'получат', 'клієнт', 'клиент', 'контакт получателя', 'контакт отримувача', 'recipient',
  ];
  for (const n of fioNames) {
    const i = normalized.findIndex((h) => h === n || (h && h.includes(n)));
    if (i >= 0) return i;
  }
  return -1;
}

export function manualCrossFioColConfigured(fioSlot, headers, renames) {
  if (!fioSlot) return false;
  const rawCol = fioSlot.col;
  if (rawCol !== '' && rawCol != null) {
    const n = Number(rawCol);
    if (Number.isFinite(n) && n >= 0) return true;
  }
  if (Array.isArray(headers) && headers.length) {
    return detectManualCrossFioCol(headers, renames) >= 0;
  }
  return false;
}

export function fillManualCrossFioFromDetect(fioBySlot, slotIndices, manualFiles, manualRenames) {
  const next = [...fioBySlot];
  let changed = false;
  slotIndices.forEach((i) => {
    if (manualCrossFioColConfigured(next[i], manualFiles[i]?.headers, manualRenames[i])) return;
    const det = detectManualCrossFioCol(manualFiles[i]?.headers || [], manualRenames[i]);
    if (det >= 0) {
      next[i] = { col: det, part: next[i]?.part || '' };
      changed = true;
    }
  });
  return { fioBySlot: next, changed };
}

export function listManualCrossFioMissingSlotLabels(slotIndices, fioBySlot, manualFiles, manualRenames, formatFileName) {
  const fmt = typeof formatFileName === 'function' ? formatFileName : (s) => s;
  return slotIndices
    .filter((i) => !manualCrossFioColConfigured(fioBySlot[i], manualFiles[i]?.headers, manualRenames[i]))
    .map((i) => {
      const fn = fmt(manualFiles[i]?.fileName || '');
      const sheet = manualFiles[i]?.excelSheetName;
      const extra = sheet ? ` → ${sheet}` : (fn ? ` (${String(fn).slice(0, 28)})` : '');
      return `Файл ${i + 1}${extra}`;
    });
}

export const MANUAL_CROSS_FIO_VALIDATION_HINT =
  'Подойдёт «Контакт отримувача» — не обязательно слово «ФИО» в заголовке. '
  + 'Если столбец разбит на телефон и ФИО, выберите вариант с пометкой «(ФИО)».';
